import Structor from "../util/structor"

export default class DateAnnotationGroupAttributes extends Structor {
  defineStruct() {
    this.field("title")
    this.field("description", "<p></p>")
    this.field("startDate")
    this.field("endDate")
    this.field("isOff")
    this.field("schoolYearId")
    this.field("isPublished")
  }
}
